<template>
  <div class="main_right ammeter-add">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">蒸汽表名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
        <span v-html="deviceNameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">蒸汽表序列号：</span>
        </div>
        <el-input v-model="code" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">蒸汽表厂家：</span>
        </div>
        <el-select v-model="deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">蒸汽表型号：</span>
        </div>
        <el-select v-model="deviceModelCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </div>

      <!--      <div class="form-line">-->
      <!--        <div class="textBox">-->
      <!--          <b class="red">*</b>-->
      <!--          <span class="line-text">蒸汽表类型：</span>-->
      <!--        </div>-->
      <!--        <el-select v-model="steamDeviceType" size="small" style="width: 280px">-->
      <!--          <el-option v-for="item in steamDeviceTypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>-->
      <!--        </el-select>-->
      <!--      </div>-->

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">接入方式：</span>
        </div>
        <el-select v-model="accessType" size="small" style="width: 280px">
          <el-option v-for="item in accessTypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="accessType === '有线'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">蒸汽表所属集中器：</span>
        </div>
        <el-select v-model="steamControlDeviceCode" size="small" style="width: 280px">
          <el-option v-for="item in steamList" :key="item.deviceCode" :label="item.name" :value="item.deviceCode"> </el-option>
        </el-select>
      </div>

      <!--      <div class="form-line">-->
      <!--        <div class="textBox">-->
      <!--          <b class="red">*</b>-->
      <!--          <span class="line-text">互感器配置：</span>-->
      <!--        </div>-->
      <!--        <el-switch v-model="mutualInductorState" active-text="是" inactive-text="否"> </el-switch>-->
      <!--      </div>-->

      <!--      <div class="form-line" v-if="mutualInductorState">-->
      <!--        <div class="textBox">-->
      <!--          <b class="red">*</b>-->
      <!--          <span class="line-text">互感器倍率：</span>-->
      <!--        </div>-->
      <!--        <el-input-number v-model="powerRate" controls-position="right" size="small" style="width: 280px" :min="1" />-->
      <!--      </div>-->

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">蒸汽表级别：</span>
        </div>
        <el-select v-model="level" size="small" style="width: 280px">
          <el-option v-for="item in levelList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="level !== 1">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">上级蒸汽表：</span>
        </div>
        <el-select v-model="parentDeviceCode" filterable remote reserve-keyword placeholder="请输入关键词" size="small" style="width: 280px" :remote-method="selectSteamMeterParent">
          <el-option v-for="item in parentDeviceList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">蒸汽表所在房间：</span>
        </div>
        <input-tree :fetch="fetchDetail" :showCheckBox="false" @chooseLine="getRoomList" :theValue="roomCode" :theName="buildingRoomName" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场景：</span>
        </div>
        <el-select v-model="scene" size="small" style="width: 280px">
          <el-option v-for="item in sceneList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </div>

      <div class="form-line steamity">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">初始蒸汽量：</span>
        </div>
        <el-input v-model="steamity" type="number" size="small" style="width: 280px" @blur="steamityBlur">
          <template slot="append">吨</template>
        </el-input>
        <span style="display: block; width: 400px">初始蒸汽量为该蒸汽表新接入系统的初始度数，该度数作为后续蒸汽的起始值，首次蒸汽值=首次蒸汽表读数-该初始读数。一经添加无法修改，请仔细核对。</span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">蒸汽类型：</span>
        </div>
        <el-select v-model="useType" size="small" style="width: 280px">
          <el-option v-for="item in useTypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </div>

      <!--      <div class="form-line">-->
      <!--        <div class="textBox">-->
      <!--          <b class="red">*</b>-->
      <!--          <span class="line-text">蒸汽表计费：</span>-->
      <!--        </div>-->
      <!--        <el-switch-->
      <!--          v-model="steamFeeTypeState"-->
      <!--          active-text="是"-->
      <!--          inactive-text="否">-->
      <!--        </el-switch>-->
      <!--      </div>-->

      <div class="form-line" v-if="autoOffSupportState">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">欠费是否关闸：</span>
        </div>
        <el-switch v-model="breaker" active-text="是" inactive-text="否"> </el-switch>
      </div>

      <!--      <div class="form-line">-->
      <!--        <div class="textBox">-->
      <!--          <b class="red">*</b>-->
      <!--          <span class="line-text">蒸汽表数据统计：</span>-->
      <!--        </div>-->
      <!--        <el-switch-->
      <!--          v-model="whetherToCount"-->
      <!--          active-text="是"-->
      <!--          inactive-text="否">-->
      <!--        </el-switch>-->
      <!--      </div>-->

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="memo" size="small" style="width: 280px" />
      </div>

      <!--<div class="form-line">-->
      <!--<div class="textBox">-->
      <!--<b class="red">*</b>-->
      <!--<span class="line-text">责任人：</span>-->
      <!--</div>-->
      <!--<el-select v-model="responsiblePersonCode"-->
      <!--filterable-->
      <!--remote-->
      <!--reserve-keyword-->
      <!--size="small" style="width: 280px"-->
      <!--:remote-method="remoteMethod"-->
      <!--placeholder="请输入关键词查询">-->
      <!--<el-option v-for="item in responsiblePersonList" :key="item._value"-->
      <!--:label="item._label" :value="item._value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--<span v-html="responsiblePersonVer"></span>-->
      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>
    </form>
  </div>
</template>

<script>
import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
import { errorHandler } from '../../../utils/errorHandler'
import InputTree from '../../../components/common/inputs/input-tree'
import { pattern } from '../../../utils/regular'
import { api } from '../../api/SteamManagement'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import { nError, nSuccess } from '../../../utils/notice'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import { treeApi } from '../../api/ElectronicTreeApi'
// let a = document.getElementsByClassName()

export default {
  components: {
    ButtonConfirmNext,
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb,
  },
  name: 'ammeter-add',
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: '智慧蒸汽',
            name: 'steam-over-view',
          },
          {
            value: '蒸汽表管理',
          },
        ],
      },
      mainTitle: '添加蒸汽表',
      subheading: '',
      autoOffSupportState: false,

      deviceName: '',
      code: '',
      deviceNameVer: '<span>不超过32个字</span>',
      deviceManufacturerCode: '山科',
      deviceManufacturerList: [
        {
          name: '山科',
          code: '山科',
        },
        {
          name: '炬华',
          code: '炬华',
        },
      ],
      deviceModelCode: 'DM-WD-001',
      deviceModelNameList: [
        {
          name: 'DM-WD-001',
          code: 'DM-WD-001',
        },
      ],
      steamDeviceType: '冷蒸汽',
      steamDeviceTypeList: [
        {
          name: '冷蒸汽',
          code: '冷蒸汽',
        },
        {
          name: '热蒸汽',
          code: '热蒸汽',
        },
      ],
      accessType: 'NB',
      accessTypeList: [
        {
          name: 'NB',
          code: 'NB',
        },
        {
          name: '有线',
          code: '有线',
        },
      ],
      steamControlDeviceCode: '',
      steamList: [],
      responsiblePersonCode: '',
      responsiblePersonList: [],
      responsiblePersonVer: '<span>蒸汽表责任人</span>',
      deviceNameHttp: false,
      deviceCodeHttp: false,
      fetchDetail: null,
      roomCode: '',
      roomName: '',
      buildingName: '',
      buildingCode: '',
      buildingRoomName: '',
      breaker: false,
      whetherToCount: false,
      steamFeeTypeState: false,
      scene: '',
      sceneList: [],
      useType: '1',
      useTypeList: [
        {
          name: '充值',
          code: '1',
        },
        {
          name: '抄表',
          code: '2',
        },
      ],
      steamity: '0',
      powerBeforesteamMeter: '',
      memo: '',
      mutualInductorState: false,
      mutualInductorOnOrOff: '0',
      powerRate: 1,

      level: 1,
      levelList: [
        {
          name: '一级',
          code: 1,
        },
        {
          name: '二级',
          code: 2,
        },
        {
          name: '三级',
          code: 3,
        },
        {
          name: '四级',
          code: 4,
        },
        {
          name: '五级',
          code: 5,
        },
      ],
      parentDeviceCode: '',
      parentDeviceName: '',
      parentDeviceList: [],
    }
  },
  created() {
    this.autoOffSupport()
    // this.getAlldeviceManufacturer()
    // this.getAllDeviceType()
    // this.getResponsiblePersonList()
    this.getSteamSceneList()
    this.getSteamControlDeviceList()
    this.fetchDetail = () => {
      let treeList = []
      let yqCode = ''

      return treeApi.getYqInfo().then((yqData) => {
        let yqObj = {}
        yqCode = yqData.yqCode
        yqObj._value = yqData.yqCode
        yqObj._label = yqData.yqName
        yqObj.parentCode = '0'
        yqObj.level = 1
        yqObj.code = yqData.yqCode
        treeList.push(yqObj)

        treeApi.getVacancyRoomInfo(this.currentCode).then((roomList) => {
          roomList.map((room) => {
            let roomObj = {}
            roomObj.buildingName = room.buildingName
            roomObj.buildingCode = room.buildingCode
            roomObj._value = room.code
            roomObj._label = room.roomNumber
            roomObj.parentCode = room.floorCode
            roomObj.level = 4
            roomObj.code = room.code
            roomObj.roomArea = room.roomArea
            roomObj.roomRent = room.roomRent
            roomObj.roomType = room.roomType
            treeList.push(roomObj)
          })
        })

        treeApi.getBuildingList().then((buildingList) => {
          buildingList.map((v) => {
            let obj = {}
            obj._value = v.code
            obj._label = v.name
            obj.parentCode = yqCode
            obj.level = 2
            obj.code = v.code
            treeList.push(obj)
            if (v.floors.length > 0) {
              v.floors.map((floor) => {
                let floorObj = {}
                floorObj._value = floor.code
                floorObj._label = floor.name
                floorObj.parentCode = floor.buildingCode
                floorObj.level = 3
                floorObj.code = floor.code
                treeList.push(floorObj)
              })
            }
          })
        })
        return treeList
      })
    }
  },
  methods: {
    // 查询是否可配置欠费是否关闸
    autoOffSupport() {
      this.$axios
        .get(api.autoOffSupport, {})
        .then((res) => {
          this.autoOffSupportState = res.data.data
        })
        .catch(errorHandler('查询配置信息失败'))
    },
    selectSteamMeterParent(query) {
      this.getSteamMeterParentList(query)
    },
    // 获取父级蒸汽表
    getSteamMeterParentList(query) {
      if (this.level !== 1) {
        this.$axios
          .post(api.getSteamMeterParentList, {
            level: this.level,
            searchKey: query || '',
          })
          .then((res) => {
            let list = res.data.data
            this.parentDeviceList = list
          })
          .catch(errorHandler('获取父级蒸汽表失败'))
      }
    },
    // 获取场景列表
    getSteamSceneList() {
      this.$axios
        .post(api.getSteamSceneList, {})
        .then((res) => {
          let list = res.data.data
          this.sceneList = list
        })
        .catch(errorHandler('获取场景列表失败'))
    },
    // 获取集中器列表
    getSteamControlDeviceList(searchKey) {
      this.$axios
        .post(api.getSteamControlDeviceList, {})
        .then((res) => {
          let list = res.data.data
          this.steamList = list
        })
        .catch(errorHandler('获取集中器列表失败'))
    },
    // 获取责任人列表
    getResponsiblePersonList(searchKey) {
      this.$axios
        .post(`${api.getResponsiblePersonList}?searchKey=${searchKey || ''}`, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let list = res.data.data
            list.forEach((it) => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone}`
            })
            this.responsiblePersonList = list
          }
        })
        .catch(errorHandler('获取责任人列表失败'))
    },

    remoteMethod(query) {
      this.getResponsiblePersonList(query)
    },
    getRoomList(data) {
      if (data) {
        this.roomCode = data._value
        this.roomName = data._label
        this.buildingName = data.buildingName
        this.buildingCode = data.buildingCode
        this.buildingRoomName = `${data.buildingName}${data._label}`
      } else {
        this.roomCode = ''
        this.roomName = ''
        this.buildingName = ''
        this.buildingCode = ''
        this.buildingRoomName = ''
      }
    },
    steamityBlur() {
      if (this.steamity === '') {
        this.steamity = '0'
      }
      this.$confirm('初始蒸汽量为该蒸汽表新接入系统的初始度数，该度数作为后续蒸汽的起始值，首次蒸汽值=首次蒸汽表读数-该初始读数。一经添加无法修改，请仔细核对。', '温馨提示', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '我知道了',
      })
    },
    addNext() {
      if (!this.deviceName) {
        this.deviceNameVer = '<span style="color: red;">请输入蒸汽表名称</span>'
        return false
      }
      if (!this.code) {
        nError('请输入蒸汽表序列号')
        return false
      }
      if (this.accessType === '有线' && !this.steamControlDeviceCode) {
        nError('请选择蒸汽表所属集中器')
        return false
      }
      if (this.level !== 1 && !this.parentDeviceCode) {
        nError('请选择上级蒸汽表')
        return false
      }
      if (!this.scene) {
        nError('请选择场景')
        return false
      }
      // if (!this.responsiblePersonCode) {
      //   this.responsiblePersonVer = '<span style="color: red;">请选择蒸汽表责任人</span>'
      //   return false
      // }
      if (!this.deviceNameHttp) {
        return false
      } else {
        this.deviceNameVer = '<span>不超过32个字</span>'
      }
      let obj = {
        name: this.deviceName,
        code: this.code,
        steamDeviceType: this.steamDeviceType,
        accessType: this.accessType,
        steamControlDeviceCode: this.steamControlDeviceCode,
        steamControlDeviceName: '',
        meterDeviceManufacturerCode: this.deviceManufacturerCode,
        meterDeviceManufacturerName: '',
        meterDeviceModelCode: this.deviceModelCode,
        meterDeviceModelName: '',
        roomCode: this.roomCode,
        roomNumber: this.roomName,
        buildingCode: this.buildingCode,
        buildingName: this.buildingName,
        sceneCode: this.scene,
        sceneName: '',
        steamity: this.steamity,
        powerBeforesteamMeter: this.powerBeforesteamMeter,
        mutualInductorOnOrOff: this.mutualInductorOnOrOff,
        powerRate: this.powerRate,
        // responsiblePersonCode: this.responsiblePersonCode,
        // responsiblePersonName: '',
        // responsiblePersonPhone: '',
        autoOff: '0',
        steamFeeType: '0',
        whetherToCount: '0',
        memo: this.memo,
        useType: this.useType,

        level: this.level,
        parentDeviceCode: this.parentDeviceCode,
        parentDeviceName: this.parentDeviceName,
      }
      if (this.breaker) {
        obj.autoOff = '1'
      } else {
        obj.autoOff = '0'
      }
      if (this.steamFeeTypeState) {
        obj.steamFeeType = '1'
      } else {
        obj.steamFeeType = '0'
      }
      if (this.whetherToCount) {
        obj.whetherToCount = '1'
      } else {
        obj.whetherToCount = '0'
      }
      this.sceneList.map((v) => {
        if (v.code === this.scene) {
          obj.sceneName = v.name
        }
      })
      if (obj.accessType === 'NB') {
        obj.steamControlDeviceCode = ''
        obj.steamControlDeviceName = ''
      }
      this.steamList.map((v) => {
        if (v.deviceCode === this.steamControlDeviceCode) {
          obj.steamControlDeviceName = v.name
        }
      })
      this.deviceManufacturerList.map((v) => {
        if (v.code === this.deviceManufacturerCode) {
          obj.meterDeviceManufacturerName = v.name
        }
      })
      this.deviceModelNameList.map((v) => {
        if (v.code === this.deviceModelCode) {
          obj.meterDeviceModelName = v.name
        }
      })
      // this.responsiblePersonList.map(v => {
      //   if (v.code === this.responsiblePersonCode) {
      //     obj.responsiblePersonName = v.name
      //     obj.responsiblePersonPhone = v.phone
      //   }
      // })
      this.$axios
        .post(api.addSteamMeterDevice, obj)
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.deviceName = ''
            this.code = ''
            this.memo = ''
            // this.responsiblePersonCode = ''
          }
        })
        .catch(errorHandler('添加蒸汽表失败'))
    },
    add() {
      if (!this.deviceName) {
        this.deviceNameVer = '<span style="color: red;">请输入蒸汽表名称</span>'
        return false
      }
      if (!this.code) {
        nError('请输入蒸汽表序列号')
        return false
      }
      if (this.accessType === '有线' && !this.steamControlDeviceCode) {
        nError('请选择蒸汽表所属集中器')
        return false
      }
      if (this.level !== 1 && !this.parentDeviceCode) {
        nError('请选择上级蒸汽表')
        return false
      }
      if (!this.scene) {
        nError('请选择场景')
        return false
      }

      // if (!this.responsiblePersonCode) {
      //   this.responsiblePersonVer = '<span style="color: red;">请选择蒸汽表责任人</span>'
      //   return false
      // }
      if (!this.deviceNameHttp) {
        return false
      } else {
        this.deviceNameVer = '<span>不超过32个字</span>'
      }
      let obj = {
        name: this.deviceName,
        code: this.code,
        steamDeviceType: this.steamDeviceType,
        accessType: this.accessType,
        steamControlDeviceCode: this.steamControlDeviceCode,
        steamControlDeviceName: '',
        meterDeviceManufacturerCode: this.deviceManufacturerCode,
        meterDeviceManufacturerName: '',
        meterDeviceModelCode: this.deviceModelCode,
        meterDeviceModelName: '',
        roomCode: this.roomCode,
        roomNumber: this.roomName,
        buildingCode: this.buildingCode,
        buildingName: this.buildingName,
        sceneCode: this.scene,
        sceneName: '',
        steamity: this.steamity,
        powerBeforesteamMeter: this.powerBeforesteamMeter,
        mutualInductorOnOrOff: this.mutualInductorOnOrOff,
        powerRate: this.powerRate,
        // responsiblePersonCode: this.responsiblePersonCode,
        // responsiblePersonName: '',
        // responsiblePersonPhone: '',
        autoOff: '0',
        steamFeeType: '0',
        whetherToCount: '0',
        memo: this.memo,
        useType: this.useType,

        level: this.level,
        parentDeviceCode: this.parentDeviceCode,
        parentDeviceName: this.parentDeviceName,
      }
      if (this.breaker) {
        obj.autoOff = '1'
      } else {
        obj.autoOff = '0'
      }
      this.parentDeviceList.map((v) => {
        if (v.code === this.parentDeviceCode) {
          obj.parentDeviceName = v.name
        }
      })
      if (this.steamFeeTypeState) {
        obj.steamFeeType = '1'
      } else {
        obj.steamFeeType = '0'
      }
      if (this.whetherToCount) {
        obj.whetherToCount = '1'
      } else {
        obj.whetherToCount = '0'
      }
      this.sceneList.map((v) => {
        if (v.code === this.scene) {
          obj.sceneName = v.name
        }
      })
      if (obj.accessType === 'NB') {
        obj.steamControlDeviceCode = ''
        obj.steamControlDeviceName = ''
      }
      this.steamList.map((v) => {
        if (v.deviceCode === this.steamControlDeviceCode) {
          obj.steamControlDeviceName = v.name
        }
      })
      this.deviceManufacturerList.map((v) => {
        if (v.code === this.deviceManufacturerCode) {
          obj.meterDeviceManufacturerName = v.name
        }
      })
      this.deviceModelNameList.map((v) => {
        if (v.code === this.deviceModelCode) {
          obj.meterDeviceModelName = v.name
        }
      })
      // this.responsiblePersonList.map(v => {
      //   if (v.code === this.responsiblePersonCode) {
      //     obj.responsiblePersonName = v.name
      //     obj.responsiblePersonPhone = v.phone
      //   }
      // })
      this.$axios
        .post(api.addSteamMeterDevice, obj)
        .then((res) => {
          nSuccess('添加成功')
          this.strategyCenter()
        })
        .catch(errorHandler('添加蒸汽表失败'))
    },
    strategyCenter() {
      this.$router.push({
        name: 'steam-ammeter-management',
      })
    },
  },
  watch: {
    deviceName(v) {
      let ptn = pattern.basicAndCN.test(v)
      if (!ptn) {
        this.deviceNameVer = '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>'
        this.deviceNameHttp = false
      } else {
        this.deviceNameVer = '<span>不超过32个字</span>'
        this.deviceNameHttp = true
      }
    },
    level() {
      this.getSteamMeterParentList()
    },
    mutualInductorState() {
      if (this.mutualInductorState) {
        this.mutualInductorOnOrOff = '1'
      } else {
        this.mutualInductorOnOrOff = '0'
        this.powerRate = 1
      }
    },
  },
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 15px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 160px;
  text-align: right;
}
.form-btn-box {
  width: 605px;
  padding: 0 162px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.ammeter-add {
  .steamity {
    .el-input__inner {
      padding: 0 0 0 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/SteamManage/AmmeterManagement/AmmeterAdd.vue